/** Registered supervisor check ids, in registry order. The audit page lists these. */
export const AUDIT_CHECK_IDS = [
  'placeholder-identifier',
  'serial-annotation',
  'ad-authority-missing',
  'sb-number-as-ad',
  'thrust-format',
  'engine-type-malformed',
  'page-sentinel-counter',
  'page-junk-registration',
  'esn-prefix-drift',
  'graph-part-key-split',
  'esn-near-duplicate',
  'pn-variant-under-serial',
  'counter-digit-concat',
  'engine-total-copied-to-parts',
  'install-without-removal',
  'future-event-date',
  'wrong-family-for-category',
  'ad-sb-status-disagreement',
  'winner-counter-stale',
  'shop-visit-uncorroborated',
  'part-on-two-engines-same-date',
  'ad-applies-to-part-not-on-engine',
  'ad-applies-to-part-serial-near-miss',
  'llp-serial-moves-without-removal',
  'consolidated-llp-counter-missing',
  'llp-life-arithmetic',
  'arc-certificate-number-missing',
  'release-document-unsigned',
  'counter-regression',
  'page-engine-type-disagreement',
  'serial-spelling-vote',
  'evidence-not-read',
  'borescope-date-unresolved',
] as const;

/** Writes `checkId` onto the page URL. An empty id clears the param (every check). */
export const withAuditCheckParam = (prev: URLSearchParams, checkId: string): URLSearchParams => {
  const next = new URLSearchParams(prev);
  if (checkId) next.set('checkId', checkId);
  else next.delete('checkId');
  return next;
};
